"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["JoinInteractionResponse"] = "joinInteractionResponse";
    MessageType["JoinInteractionRequest"] = "joinInteractionRequest";
    MessageType["SetAuthenticationFactorRequest"] = "setAuthenticationFactorRequest";
    MessageType["SetAuthenticationFactorResponse"] = "setAuthenticationFactorResponse";
    MessageType["AuthenticationFactorSetRequest"] = "authenticationFactorSetRequest";
    MessageType["AuthenticationFactorSetResponse"] = "authenticationFactorSetResponse";
    MessageType["InteractionCompletedRequest"] = "interactionCompletedRequest";
    MessageType["InteractionCompletedResponse"] = "interactionCompletedResponse";
    MessageType["ChallengeCustomerRequest"] = "challengeCustomerRequest";
    MessageType["ChallengeCustomerResponse"] = "challengeCustomerResponse";
    MessageType["CustomerChallengedRequest"] = "customerChallengedRequest";
    MessageType["CustomerChallengedResponse"] = "customerChallengedResponse";
    MessageType["EngageEndpointRequest"] = "engageEndpointRequest";
    MessageType["EngageEndpointResponse"] = "engageEndpointResponse";
    MessageType["EndpointEngagedRequest"] = "endpointEngagedRequest";
    MessageType["EndpointEngagedResponse"] = "endpointEngagedResponse";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
//# sourceMappingURL=MessageType.js.map